import { createContext, useContext } from 'react';
import { noop } from '../utils';
export var defaultContext = {
  activeIndex: -1,
  hintText: '',
  id: '',
  initialItem: undefined,
  inputNode: null,
  isOnlyResult: false,
  onInitialItemChange: noop,
  setItem: noop
};
export var TypeaheadContext = /*#__PURE__*/createContext(defaultContext);
export var useTypeaheadContext = function useTypeaheadContext() {
  return useContext(TypeaheadContext);
};